// extracted by mini-css-extract-plugin
module.exports = {"displayLinebreak":"end-user-license-agreement_displayLinebreak__2bQv4"};